import React from "react"
import { AI_PRICES } from "../types/ai-dashboard"

const PriceInfoCard: React.FC = () => (
     <div className="alert alert-info border-0 shadow-sm d-flex align-items-center mb-4">
          <i className="bi bi-tag-fill me-3 h4 mb-0"></i>
          <div className="small">
               <span className="fw-bold">Tarifs OpenAI (pour 1M tokens) :</span>
               <span className="ms-3">
                    Input : <span className="badge bg-white text-dark border">${AI_PRICES.INPUT_NORMAL}</span>
               </span>
               <span className="ms-2">
                    Input Cache : <span className="badge bg-white text-dark border">${AI_PRICES.INPUT_CACHED}</span>
               </span>
               <span className="ms-2">
                    Output : <span className="badge bg-white text-dark border">${AI_PRICES.OUTPUT}</span>
               </span>
          </div>
     </div>
)

export default PriceInfoCard
